import * as Yup from 'yup';
import {
  CasDocumentationField,
  CasReactHookFormDialog,
  CasRHFUpload,
} from 'src/compass/shared/components';
import useUploadMutation from 'src/compass/shared/hooks/reactQuery/useUploadMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { CasRHFFormDialogProps } from '../CasForm/CasReactHookFormDialog';

type CasUploadDialogProps = Omit<CasRHFFormDialogProps, 'children' | 'schema'| 'onSubmit'> & {
  onUploadSuccess: Function;
  url: string;
  params?: Record<string, any>;
  documentation?: string | JSX.Element;
};

const UploadSchema = Yup.object().shape({
  file: Yup.mixed().required('File is required.'),
});

export default function CasUploadDialog({
  title,
  open,
  url,
  params,
  documentation,
  onUploadSuccess,
  onClose,
  ...rest
}: CasUploadDialogProps) {
  const mutation = useUploadMutation({
    url,
    params,
    onSuccess: (data) => {
      onUploadSuccess(data);
      onClose();
      onSuccessEnqueueSnackbar(data);
    },
  });

  const { mutate } = mutation;

  const onSubmit = ({ file }: { file: File }) => mutate({ file });

  return (
    <CasReactHookFormDialog
      open
      title={title}
      submitButtonLabel="Upload"
      schema={UploadSchema}
      onSubmit={onSubmit}
      onClose={onClose}
      {...rest}
    >
      <CasRHFUpload name="file" accept=".xlsx" />
      {documentation && <CasDocumentationField value={documentation} />}
    </CasReactHookFormDialog>
  );
}
